/**
 * @Description For protected routers
 * @FileName protectedRoute.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 25 January, 2021 12:17:55
 * @IssueID - 311
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import FasatErrorBoundary from '../fasatErrorBoundary/fasatErrorBoundary';
import { isHasUserClaim } from '../../util';

/**
 * This route would be protected and would only be available for the
 * authenticated and authorized user
 * @param {object}  - component and other Route properties
 */
export function FasatProtectedRoute({ component: Component,
  aclKey: AclKey, userClaim, ..._rest }) {
  // check if there is any access token
  // dispatch token validation action
  if (isHasUserClaim(userClaim, AclKey)) {
    return (
      <FasatErrorBoundary fallback={<div> Error From route</div>}>
        <Component />
      </FasatErrorBoundary>
    );
  }
  return <Navigate to={{ pathname: '/' }} />;
}

FasatProtectedRoute.propTypes = {
  component: PropTypes.object.isRequired,
  aclKey: PropTypes.object.isRequired,
  userClaim: PropTypes.object.isRequired,
};

/**
 * This route would be accessible to all. e.g. application home page
 * authenticated and authorized user
 * @param {object}  - component and other Route properties
 */
export function FasatPublicRoute({ component: Component, ..._rest }) {
  return (
    <FasatErrorBoundary fallback={<div> Error From route</div>}>
      <Component />
    </FasatErrorBoundary>
  );
}

FasatPublicRoute.propTypes = {
  component: PropTypes.object.isRequired,
};
